import { DataProvider } from "@refinedev/core";
import { IDataContextProvider } from "@refinedev/core/dist/contexts/data/IDataContext";
import { AxiosInstance } from "axios";
import axAPI from "../../../api/axios-instance";
import { MedicineAnnouncementFormValues } from "../Medicine-Announcements/types";

const ANNOUNCEMENTS_URL = "/cms/medicine/event-announcements";

export const medicineAnnouncementsDataProvider = (
  apiUrl: string,
  httpClient: AxiosInstance = axAPI
): DataProvider =>
  <IDataContextProvider>{
    getApiUrl: () => apiUrl,
    getList: async ({ resource }) => {
      try {
        const { data } = await httpClient.get(ANNOUNCEMENTS_URL);
        const announcements = data?.announcements || [];

        return {
          data: announcements,
          total: announcements.length,
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    getOne: async ({ id }) => {
      try {
        const { data } = await httpClient.get(`${ANNOUNCEMENTS_URL}/${id}`);

        return {
          data,
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    create: async ({ variables }) => {
      try {
        const { data } = await httpClient.post(ANNOUNCEMENTS_URL + "/upsert", {
          ...(variables as MedicineAnnouncementFormValues),
          id: null,
        });

        return {
          data,
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    update: async ({
      variables,
    }: {
      id: string;
      resource: string;
      variables: MedicineAnnouncementFormValues;
    }) => {
      try {
        const { data } = await httpClient.post(
          ANNOUNCEMENTS_URL + "/upsert",
          variables
        );

        return {
          data,
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    deleteOne: async ({ id }) => {
      try {
        const { data } = await httpClient.post(
          `${ANNOUNCEMENTS_URL}/remove/${id}`
        );

        return {
          data,
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
  };
